import React from 'react'
import { Helmet } from "react-helmet";

function Privacy() {
    return (
        <>
            <Helmet>
                <title>Privacy & Policy</title>
                < meta name="description" content="Privacy & Policy" />
            </Helmet>
            <div style={{ padding: '1rem' }}>
                <h1>Terms and Conditions for Company Name</h1>

                <h2>Introduction</h2>
                <p>
                    These Website Standard Terms and Conditions written on this webpage shall manage your use of our website, Website Name accessible at Website.com.
                </p>
                <p>
                    These Terms will be applied fully and affect your use of this Website. By using this Website, you agreed to accept all terms and conditions written here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions.
                </p>
                <p>
                    Minors or people below 18 years old are not allowed to use this Website.
                </p>

                <h2>Intellectual Property Rights</h2>
                <p>
                    Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.
                </p>
                <p>
                    You are granted a limited license only for purposes of viewing the material contained on this Website.
                </p>

                <h2>Restrictions</h2>
                <p>You are specifically restricted from all of the following:</p>
                <ul>
                    <li>Publishing any Website material in any other media;</li>
                    <li>Selling, sublicensing and/or otherwise commercializing any Website material;</li>
                    <li>Publicly performing and/or showing any Website material;</li>
                    <li>Using this Website in any way that is or may be damaging to this Website;</li>
                    <li>Using this Website in any way that impacts user access to this Website;</li>
                    <li>Using this Website contrary to applicable laws and regulations;</li>
                    <li>Engaging in any data mining, data harvesting, or data extracting;</li>
                    <li>Using this Website for advertising or marketing without authorization.</li>
                </ul>
                <p>
                    Certain areas of this Website are restricted from being accessed by you and Company Name may further restrict access to any areas of this Website, at any time, in absolute discretion.
                </p>
                <p>
                    Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.
                </p>

                <h2>Your Content</h2>
                <p>
                    “Your Content” means any audio, video, text, images, or other material you display on this Website. By displaying Your Content, you grant Company Name a non-exclusive, worldwide, irrevocable, sublicensable license to use, reproduce, adapt, publish, translate, and distribute it in any and all media.
                </p>
                <p>
                    Your Content must be your own and must not invade any third-party's rights. Company Name reserves the right to remove any of Your Content from this Website at any time without notice.
                </p>

                <h2>No Warranties</h2>
                <p>
                    This Website is provided “as is,” with all faults, and Company Name makes no representations or warranties, of any kind, related to this Website or the materials contained on it.
                </p>
                <p>
                    Nothing contained on this Website shall be interpreted as advising you.
                </p>

                <h2>Limitation of Liability</h2>
                <p>
                    In no event shall Company Name, nor its officers, directors, or employees, be held liable for anything arising from or in any way connected with your use of this Website.
                </p>
                <p>
                    Company Name shall not be liable for any indirect, consequential, or special liability related to your use of this Website.
                </p>

                <h2>Indemnification</h2>
                <p>
                    You hereby indemnify to the fullest extent Company Name from and against any and all liabilities, costs, demands, causes of action, damages, and expenses arising in any way related to your breach of any of these Terms.
                </p>

                <h2>Severability</h2>
                <p>
                    If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.
                </p>

                <h2>Variation of Terms</h2>
                <p>
                    Company Name is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.
                </p>

                <h2>Assignment</h2>
                <p>
                    Company Name may assign, transfer, and subcontract its rights and/or obligations under these Terms without notification. You are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.
                </p>

                <h2>Entire Agreement</h2>
                <p>
                    These Terms constitute the entire agreement between Company Name and you in relation to your use of this Website, superseding all prior agreements and understandings.
                </p>

                <h2>Governing Law & Jurisdiction</h2>
                <p>
                    These Terms will be governed by and interpreted in accordance with the laws of the State of [Country], and you submit to the non-exclusive jurisdiction of the state and federal courts located in [Country] for the resolution of any disputes.
                </p>
            </div>
        </>
    );
}

export default Privacy;